export type WebhookTriggerOption = {
  id: string
  name: string
}

export const WEBHOOK_TRIGGERS: WebhookTriggerOption[] = [
  { id: 'registration.created', name: 'Registration.created' },
  { id: 'registration.approved', name: 'Registration.approved' },
  { id: 'registration.declined', name: 'Registration.declined' },
  { id: 'registration.deleted', name: 'Registration.deleted' },
  { id: 'registration.attended', name: 'Registration.attended' },
  { id: 'registration.printed', name: 'Registration.printed' }
]
